import { forwardRef } from 'react';
import styled from 'styled-components';

import useColor from '@/hooks/domain/useColor';
import { cn } from '@/lib/cn';

import type { TypoProps } from './types';
import Typo from './Typo';

type TypoRef = HTMLSpanElement | HTMLParagraphElement;

const PageHeaderTitle = styled(
  forwardRef<TypoRef, TypoProps>((props, ref) => (
    <Typo {...props} type="label1" weight="sb" ref={ref} />
  )),
)`
  color: ${(props) => props.theme.colors.gray800};
`;

const SectionTitle = styled(
  forwardRef<TypoRef, TypoProps>((props, ref) => (
    <Typo {...props} type="label2" weight="sb" ref={ref} />
  )),
)`
  color: ${(props) => props.theme.colors.gray800};
`;

const ContentTitle = styled(
  forwardRef<TypoRef, TypoProps>((props, ref) => (
    <Typo {...props} type="label2" weight="m" ref={ref} />
  )),
)`
  color: ${(props) => props.theme.colors.gray700};
`;

const ModalTitle = styled(
  forwardRef<TypoRef, TypoProps>((props, ref) => (
    <Typo {...props} type="label0" weight="sb" ref={ref} />
  )),
)`
  color: ${(props) => props.theme.colors.gray800};
`;

const AttrText = (props: TypoProps) => {
  const color = useColor();
  return (
    <Typo {...props} type="body3" weight="m" color={color.gray600}>
      {props.children}
    </Typo>
  );
};

const MainText = (
  props: TypoProps & {
    dim?: boolean;
  },
) => {
  const { dim, className, children, multilineEllipsis, ...rest } = props;
  return (
    <Typo
      type="label3"
      className={cn(dim ? 'text-gray-600' : 'text-gray-700', className)}
      multilineEllipsis={multilineEllipsis}
      {...rest}
    >
      {children}
    </Typo>
  );
};

export {
  AttrText,
  ContentTitle,
  MainText,
  ModalTitle,
  PageHeaderTitle,
  SectionTitle,
};
